import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-with-ketto',
  templateUrl: './work-with-ketto.component.html',
  styleUrls: ['./work-with-ketto.component.scss']
})
export class WorkWithKettoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
